import { ajaxPostJson, setParams } from "./ajax"
//消息列表请求
export const myMessageList = (params) => {
  params.filter = setParams(params.filter);
  return ajaxPostJson(`/user/queryUserMessagePage`, params);
}
//消息同意拒绝状态修改
export const updateMessageStatus = (params) => {
  return ajaxPostJson(`/companyUser/updateInviteByUser`, params);
}
//查看详情
export const getTaskDetail = (params) => {
  return ajaxPostJson(`/fileTask/getTaskDetail`, params);
}
//点击已读
export const getMessage = (params) => {
  return ajaxPostJson(`/user/readUserMessage`, params);
}
//获取消息红点状态
export const getMessageStatus = (params) => {
  return ajaxPostJson(`/user/getMessageReadStatus`, params);
}
//删除消息
export const deleteUserMessage = (params) => {
  return ajaxPostJson(`/user/deleteUserMessage`, params);
}
//删除消息
export const getMessageReadCount = (params) => {
  return ajaxPostJson(`/user/getMessageReadCount`, params);
}
